import React, {
  useCallback,
  ForwardRefRenderFunction,
  useImperativeHandle,
  useState,
  forwardRef,
} from "react";

import { ShipmentOrdersRecourseProvider } from "../../../../../components/Shipments/context/AvailableOrders";
import { ErrorsProvider } from "../../../../../components/Shipments/context/Errors";
import { ShipmentResourcesProvider } from "../../../../../components/Shipments/context/Resources";
import { ShipmentProvider } from "../../../../../components/Shipments/context/Shipment";
import { ShipmentViewTabs } from "./components/Tabs";

interface Props {
  defaultTab?: string;
}

export interface ShipmentViewHandles {
  open: (shipmentId: number) => void;
  close: () => void;
}

const ShipmentViewComponent: ForwardRefRenderFunction<ShipmentViewHandles, Props> = (
  props,
  ref
) => {
  const { defaultTab } = props;
  const [isSidebarOpened, setIsSidebarOpened] = useState<boolean>(false);
  const [keyId, setKeyId] = useState<number>();

  const onOpenSidebar = useCallback(
    (shipmentId: number) => {
      // eslint-disable-next-line
      if (keyId != shipmentId) setKeyId(shipmentId);

      setIsSidebarOpened(true);
    },
    [keyId]
  );

  const onCloseSidebar = useCallback(() => {
    setIsSidebarOpened(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open: onOpenSidebar,
    close: onCloseSidebar,
  }));

  return (
    <ShipmentProvider>
      <ShipmentResourcesProvider>
        <ShipmentOrdersRecourseProvider>
          <ErrorsProvider>
            <ShipmentViewTabs
              keyId={keyId}
              isSidebarOpened={isSidebarOpened}
              onCloseSidebar={onCloseSidebar}
              defaultTab={defaultTab}
            />
          </ErrorsProvider>
        </ShipmentOrdersRecourseProvider>
      </ShipmentResourcesProvider>
    </ShipmentProvider>
  );
};

export default forwardRef(ShipmentViewComponent);
